export default __webpack_public_path__ + "static/media/ya.f534d1d5.jpg";